import { Component, Input, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { DiffContextService } from '../diff-context.service';

import * as _ from 'lodash';

@Component({
    selector: 'gf-diff',
  template: require('./diff.component.html')
})
export class DiffComponent implements OnInit {
  @Input() diffs: any = [];
  @Input() trackeritems: any;
  @Input() commit: any;
  @Input() allowComments: boolean;
  @Input() project: any;
  @Input() raw?: boolean;
  @Input() blame?: any;
  @Input() highlight?: string;
  @Input() fileHistory?: boolean;

  currentProject: string;
  lastLine: any;
  viewType: string = 'code';
  view: string;
  committer: any = null;
  blameData = [];

  stateParams: any = {};
  
  constructor(
    private diffContextService: DiffContextService,
    private stateService: StateService,
  ) {
  }

  ngOnInit() {
    this.setup();
  }

  ngOnChanges() {
    this.setup();
  }

  setup() {
    this.stateParams = this.stateService.params;

    if (!this.diffs) {
      this.diffs = [];
    }

    if (!this.commit) {
      this.commit = {
        meta: null,
        rel: null
      };
    }

    if (this.commit) {
      this.committer = this.commit?.author ?? null;
    }

    let lastCommit = '';
    this.blameData = _.map(
      this.blame?.lines || [],
      (line: any) => {
        const ret = {
          showDetails: lastCommit != line.blame?.commit.hash,
          popoverContent: this.getPopoverContent(line),
          ...line,
        };
        lastCommit = line.blame?.commit.hash;
        return ret;
      }
    );

    this.currentProject = this.stateParams.unixName || '';
    this.raw = this.raw || false;
    this.fileHistory = this.fileHistory || false;
    this.blame = this.blame || false;

    this.lastLine = false;
    this.viewType = 'code';

    this.view = this.view || this.stateParams.view || 'sbs';
    this.highlight = this.highlight || this.stateParams.highlight || '';

    if (this.view !== 'sbs' && this.view !== 'raw'  && this.view !== 'blame') {
      this.view = 'inline';
    }

  }

  getPopoverContent(line: any) {
    return `<h4>${line.blame.commit.hash.slice(0,7)}</h4>
            <p style="margin-bottom: .5em;">
                <span>${ line.blame.commit.timestamp.toLocaleString() }</span>
                <br />
                <span>${ line.blame.commit.author.name }</span>
            </p>
            <p class="commit-message" style="margin-bottom: 1em;">${ line.blame.commit.message }</p>`;
  }

  getContextLines(diff: any, idx: number) {
    return this.diffContextService.getContextLines(diff, idx);
  }

  shouldShowContext(diff: any, idx: number, comment: any) {
    return this.diffContextService.shouldShowContext(diff, idx, comment);
  }

  getCommitLine(line: any) {
    return this.diffContextService.getCommitLine(line);
  }

  isSingleCommit() {
    return _.get(this.commit, 'commitHash', false);
  }

  setView(viewType: string) {
    this.view = viewType;
  }

  showDownloadLink() {
    return !!this.stateParams.path;
  }

  getDownloadUrl(commitHash: string) {
    const commitishType = commitHash
      ? 'commit'
      : this.stateParams.commit
      ? 'commit'
      : this.stateParams.branch
      ? 'branch'
      : 'tag';

    const commitish = commitHash
      ? commitHash
      : this.stateParams.commit
      ? this.stateParams.commit
      : this.stateParams.branch
      ? this.stateParams.branch
      : this.stateParams.tag;

    const params = {
      unixName: this.stateParams.unixName,
      path: this.stateParams.path,
      commitishType: commitishType,
      commitish: commitish
    };

    return `/api/scm/${params.unixName}/raw/${params.path}?${params.commitishType}=${params.commitish}`;
  }

  addComment(diff: any, idx: number) {
    if (this.lastLine) {
      this.resetComments(this.lastLine);
      this.lastLine = false;
    }

    if (!this.allowComments) return false;

    const line = diff.lines[idx];

    if (!line || line.type === 'chunk') {
      return false;
    }

    if (!Array.isArray(_.get(line, 'comments', false))) {
      line.comments = [];
    }

    this.lastLine = line;
  }

  commentCount(diff: any) {
    return _.reduce(diff.lines, (carry: number, line: any) => carry + _.size(_.get(line, 'comments', [])), 0);
  }

  resetComments(line: any) {
    if (Array.isArray(_.get(line, 'comments', false))) {
      line.comments = _.filter(line.comments, 'id');
      if (line.comments.length === 0) {
        line.comments = false;
      }
    }
  }

  cancelComment(line: any) {
    this.resetComments(line);
    if (this.lastLine) {
      this.resetComments(this.lastLine);
      this.lastLine = false;
    }
  }

  anyComments(commit: any) {
    //ToDo: do we need this method?
    //return this.commentTotal(commit) > 0;
  }

  hasOrphans(o: any) {
    return _.size(_.get(o, 'orphanComments', [])) > 0;
  }

  orphanCount(diff: any) {
    return _.size(_.get(diff, 'orphanComments', []));
  }

  anyOrphans(commit: any, diffs: any[]) {
    if (this.orphanCount(commit)) return true;

    return _.sum(_.map(diffs, this.orphanCount)) > 0;
  }

    trackByFileName(index: number, diff: any): any {
        return diff?.fileName ?? diff;
    }
}
